import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-case-practice-authorization-list",
  templateUrl: "./case-practice-authorization-list.component.html",
  styleUrls: [
    "./case-practice-authorization-list.component.css",
  ],
})
export class CasePracticeAuthorizationListComponent
  implements OnInit, AfterViewInit {
  @Input() practiceList: any;
  @Input() practiceId: any;
  @Input() learningPathId: any;
  @Input() exerciseMetaId: number;
  @Input() type: string;

  @Output() onGoToNextStep = new EventEmitter<any>();
  @Output() onSetPracticeIndex = new EventEmitter<any>();
  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  learningTour: boolean;
  chuanjie: any;
  isTencent = false; // 是否腾讯对接

  //进入新能力考核标识
  version: number = 0;
  //学习 metaId
  learningPathMetaId: number = 0;
  //学习meta 列表
  learningPathMetas: any;
  goPostSurveyFlag: boolean;
  isOpenClass: number = 0;
  isShowQuestionnaire: boolean = false;
  isShowApproach: boolean = false;
  questionnaireInfo: any = null;
  learningPathSubItems: any;
  currentIndex: number = 0;
  isCustomLock: boolean = false;
  approachTheme: any = {};
  stepIndex: number = 0;

  projectId: string;
  lock: boolean = false;
  isShowToast: boolean = false;
  promptText: string;
  get showGoToSurveyBtn(): boolean {
    return this.practiceList.every(item => {
      return item.status === 2;
    })
  }
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private platformLocation: PlatformLocation,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    // ---Stephen add 2025-03-07---
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🐂🐂🐂🐂🐂🐂');
    // -------------------------------------------------------------------
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    localStorage.setItem("moduleId","3");
    let temp = true;
    this.projectId = localStorage.getItem("projectId")
    let projectmsg = JSON.parse(localStorage.getItem('projectmsg'))
    if (this.projectId && projectmsg) {
      projectmsg.map(item => {
        if (item.type == 4 && item.lockType == 1) {
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`
        }
      })
    }
    //loadconfig
    this.apiService
      .loadConfig("./assets/config/practiceList.json")
      .subscribe((result) => {
        this.practiceList.forEach(function (item, index) {
          if (result[item.title] != null) {
            item["extends"] = result[item.title];
          }
        });
      });
    this.practiceListInit();
  }

  //初始化情景模拟列表
  practiceListInit(): void {
    this.getLearningTour().then(result => {
      this.learningPathMetas = result.learning_path_metas;
    }).then(() => {
      return this.getLearningPathMetaId(this.learningPathId).then(result => {
        $('#learningPathMetaIdContainer').val(result.data)
        return this.learningPathMetaId = result.data;
      })
    }).then(() => {
      return this.getPracticeComment(this.learningPathId, { learningPathId: this.learningPathId }).then(result => {
        return this.chuanjie = result.length >= 4 ? result[2].comment : '';
      })
    }).then(() => {
      return this.commonService.getOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).then(result => {
        return this.finishStatus = result == 1;
      })
    }).then(() => {
      return this.getOrCreateLearningPath(String(this.learningPathMetaId)).then(result => {
        return this.learningPath = result;
      })
    }).then(() => {
      return this.getProgress(this.learningPathMetaId).then(result => {
        //向LMS传递进度
        if(localStorage.getItem("source_env") === "LMS_SCORM"){
          this.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',result[0].progressList[0].progress,"data");
        }
        return this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
      })
    }).then(() => {
      return this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result => {
        return this.questionnaireInfo = result;
      })
    }).then(() => {
      let temp = true;
      this.commonService.setCustomLockDate(this.learningPath, Date());
      this.learningPathSubItems = this.learningPath.subItems;
      for (let i = 0; i <= this.practiceList.length - 1; i++) {
        if (this.practiceList[i].status != 2) {
          temp = false;
        }
      }
      this.finished = temp;
      setTimeout(() => {
        if (this.finished) {
          //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
          if (this.version == 1) {
            $("#surveyBtn").fadeIn(200);
          } else {
            $("#nextWrap").show().animate({ bottom: 0 });
          }
        }
      }, 1000);
    }).then(() => {
      this.approachTheme.colorSystem = 'dark';
      this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
      this.approachTheme.currentIndex = this.currentIndex - 2;
      this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
      this.approachTheme.btnTxt = '开启能力考核';
      this.isShowQuestionnaire = this.questionnaireInfo && this.questionnaireInfo.length === 0 && this.learningPathSubItems.length === 4 && this.learningPathSubItems.filter(d => d.type === 3)[0].progress === 100 && this.learningPathSubItems.filter(d => d.type === 4)[0].progress !== 100;
    }).then(() => {
      this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
      this.isCustomLock = this.learningPathSubItems.length === 4 && this.learningPathSubItems[3].isLock ? this.learningPathSubItems : false;
      this.isShowApproach = true;
    });
  }


  //获取进度
  getProgress(learningPathMetaId: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
    }).toPromise();
  }

  //获取learningPath
  getOrCreateLearningPath(learningPathMetaId: any): Promise<any> {
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  //获取传接
  getPracticeComment(learningPathId: any, data: object): Promise<any> {
    return this.apiService.ajax({
      type: "get",
      url: "/api/concatenation/" + learningPathId,
      data: data
    }).toPromise();
  }

  //获取learningTour
  getLearningTour(): Promise<any> {
    return this.apiService.ajax({
      type: "get",
      url: "/sr/learningtournew",
    }).toPromise();
  }

  //获取learningPathMetaId
  getLearningPathMetaId(learningPathId: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
    }).toPromise();
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: "white",
    });
  }

  goToNextStep(i) {
    $('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId)
    if (this.practiceList[0].status !== 2) {
      this.exerciseMetaId = $('#exerciseMetaId').val()
      this.apiService.learingTime({ learningPathMetaId: $('#learningPathMetaIdContainer').val(), module: "情景模拟", courseUnit: '', type: 1, btnName: this.exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(result => {
        console.log(result)
      })
      this.commonService.sendPostMessage(0, 'isPractice' + 'Complete')
    }
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
    this.onSetPracticeIndex.emit(i);
    if (this.practiceList[i].status == 2) {
      let link = [
        "case-practice-report-new",
        this.practiceId,
        this.practiceList[i].id,
        this.learningPathId,
      ];
      if (this.type) {
        this.router.navigate(link, { queryParams: { type: 'huatek' } });
      } else {
        this.router.navigate(link);
      }
    } else {
      this.toNextStep(this.exerciseMetaId, [701, 702, 703, 704], i).then();
    }
  }

  //进入阶段（情景模拟MetaId，记录OnceTypeId，情景模拟下标）
  async toNextStep(exerciseMetaId: number, typeId: Array<number>, practiceIndex: number): Promise<void> {
    do {
      if (await this.getOnceValue(this.commonService.getOnceValue(exerciseMetaId, typeId[this.stepIndex]))) {
        if (this.stepIndex == typeId.length - 1) {
          let link = ["case-practice-authorization-main", this.learningPathId, this.practiceId, this.practiceList[practiceIndex].id]
          if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
          } else {
            this.router.navigate(link);
          }
        }
      } else {
        this.stepIndex = typeId[this.stepIndex] % 700;
        this.onGoToNextStep.emit(this.stepIndex);
        return;
      }
      this.stepIndex++;
    } while (this.stepIndex < typeId.length);

  }

  getOnceValue(value): Promise<void> {
    return this.commonService.getOnceIno(value).then(result => {
      return result;
    })
  }

  close() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        // 只在learningTour里出现，当完成能力是退出进入map
        if ((this.finishStatus || !this.finished) && this.learningTour) {
          let link = ["learning-map", 3];
          this.router.navigate(link);
        } else if (!this.finishStatus && this.finished && this.learningTour) {
          this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe(() => {
            this.router.navigate(["learning-map", 3]);
          });
        } else {
          let learningPathId = null
          let courseId = null
          this.route.queryParams.subscribe(queryParams => {
            learningPathId = queryParams['learningPathId']
            courseId = queryParams['courseId']
          })
          if (learningPathId && courseId) {
            let link = ['course-new', learningPathId, courseId];
            this.router.navigate(link);
          } else {
            let link = ["learning-path", this.learningPathMetaId];
            this.router.navigate(link);
          }
        }
      });
  }

  goToPostSurvey() {
    if (this.type === 'huatek') {
      this.commonService.sendPostMessage(1, 'goPostSurvey')
      return
    } else {
      if (this.lock) {
        this.showToast();
        return
      }

      this.apiService
        .ajax({
          type: "GET",
          url:
            "/sr/exposeoutapi/setAbilitySession/" +
            this.learningPathMetaId +
            "/4",
        })
        .subscribe((result) => { });
      // let link = ["survey", this.learningPathId, 7, 1];
      // //新能力考核
      // if (this.version == 1) {
      //   link = ["ability-survey", this.learningPathMetaId, 2];
      // }
      let link = ["ability-survey", this.learningPathMetaId, 2];
      // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'情景模拟','btnName':this.approachTheme.btnTxt}).then();
      this.router.navigate(link);
    }

  }

  showToast() {
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 2000);
  }

  finish() {
    if (this.finishStatus) {
      return;
    } else {
      this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe();
      let link = ["learning-map"];
      this.router.navigate(link);
    }
  }

  closeQuestionnaire() {
    this.isShowQuestionnaire = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-list/case-practice-authorization-list.component.ts